/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Files_Left_To_BeginInputs */

const en_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select files using the input on the left to begin`)
};

const fr_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez des fichiers à gauche pour commencer`)
};

const de_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie zum Starten Dateien über die Eingabefelder auf der linken Seite aus.`)
};

const it_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionare i file utilizzando l'input a sinistra per iniziare`)
};

const ru_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для начала выберите файлы, используя поле ввода слева.`)
};

const es_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione archivos utilizando la entrada de la izquierda para comenzar`)
};

const zh_cn2_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用左侧的输入框选择文件开始`)
};

const ja_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左の入力を使用してファイルを選択して開始します`)
};

const hi_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू करने के लिए बाईं ओर दिए गए इनपुट का उपयोग करके फ़ाइलें चुनें।`)
};

const pt_pt2_select_files_left_to_begin = /** @type {(inputs: Select_Files_Left_To_BeginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os arquivos usando a entrada à esquerda para começar.`)
};

/**
* | output |
* | --- |
* | "Select files using the input on the left to begin" |
*
* @param {Select_Files_Left_To_BeginInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_files_left_to_begin = /** @type {((inputs?: Select_Files_Left_To_BeginInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Files_Left_To_BeginInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_files_left_to_begin(inputs)
	if (locale === "de") return de_select_files_left_to_begin(inputs)
	if (locale === "it") return it_select_files_left_to_begin(inputs)
	if (locale === "ru") return ru_select_files_left_to_begin(inputs)
	if (locale === "es") return es_select_files_left_to_begin(inputs)
	if (locale === "zh-CN") return zh_cn2_select_files_left_to_begin(inputs)
	if (locale === "ja") return ja_select_files_left_to_begin(inputs)
	if (locale === "hi") return hi_select_files_left_to_begin(inputs)
	if (locale === "pt-PT") return pt_pt2_select_files_left_to_begin(inputs)
	return en_select_files_left_to_begin(inputs)
});